var exports = {
  "n": "Merger__gerw1D",
};

module.exports = exports;
